export default __webpack_public_path__ + "static/media/cancelled-icon.dd763f91.svg";